import { useState } from 'react';
import { useTheme } from "@emotion/react";
import PropTypes from "prop-types";
import { ButtonPill, Text } from "@/base";
import useBreakpoints from "@util/breakpoints";

import {
  priceRange,
  priceRangeStyles,
  descriptionStyles,
  playButton,
  aspectContainer,
}
  from "../helpers/styleHelpers";
import Video from "./Video";
import { buttonClick } from "../../util/buttonClick";
import CmsImageLoader from "./CmsImageLoader";

const Card = ({
  color,
  imageUrl,
  imageAlt,
  kicker,
  text,
  ctaUrl,
  ctaText,
    buttonTheme,
  iconUrl,
  iconCaption,
  isVideo,
  videoId,
  videoProvider,
  ...props
}) => {

  const theme = useTheme();

  const [videoActive, setVideoActive] = useState(false)

  const imageOrVideo = () => {

    let attrs = {
      css: aspectContainer,
      style: { cursor: isVideo ? 'pointer' : 'auto' },
      onClick: isVideo ? () => setVideoActive(true) : () => { },
      tabIndex: 0,
      onKeyDown: () => buttonClick(),
      role: 'button'
    }

    let content = (
      <>
          <CmsImageLoader css={{ width: "100%", height: "100%", objectFit: "cover", position: "absolute" }}
                          url={imageUrl} alt={imageAlt} />
          {isVideo? <div css={playButton}><span /></div> : ""}
      </>

      
    );

    if (videoActive) {
      content = <Video video_id={videoId} video_provider={videoProvider} />;
    }

    return (
      <div className="card_obj" {...attrs}>
        {content}
      </div>
    )


  }

  const buttonTitleContainer = useBreakpoints([theme.breakpoint.ns])({
    flexDirection: "row",
    alignItems: "center",
    textAlign: "center",
    display: ["block", "flex"],
    padding: "1.6rem 1.6rem 0.8rem"
  });

  const titleStyles = useBreakpoints([theme.breakpoint.ns])({
    alignContent: "center",
    paddingRight: [0, "2.4rem"],
    marginBottom: ["1em", "0"],
    fontFamily: theme.header.fontFamily,
    fontWeight: "bold",
    fontSize: "1.11em !important",
    letterSpacing: "0.01em",
    textAlign: ["center", "left"],

    color: "#000000",
  });


  // TODO: abstract border/padding into theme/props

  const makeButton = () => {
    if(!ctaText) return;
    if(ctaText.trim().length > 0){

      return (
          <ButtonPill
              buttonTheme={buttonTheme}
              to={ctaUrl}
              data-aos="fade-up"
              data-aos-delay={400}>
            {ctaText}
          </ButtonPill>
      )

    }


  }

  return (
    <div className="card" {...props}>
      <div
        css={{
          background: theme.colors.background[color][theme.variant],
        }}
      >

        {imageOrVideo()}


        <div className="card_body justify-content-between" css={buttonTitleContainer}>
          <Text className="card_bodyText" stylesOverride={titleStyles}>
            <div data-aos="fade-up" data-aos-delay={200}>{kicker}</div>
          </Text>
          {makeButton()}
        </div>

        <Text className="card_bodyDesc" stylesOverride={descriptionStyles}><div dangerouslySetInnerHTML={{ __html: text }} /></Text>

        {(iconCaption || iconUrl) && (
          <div className="card_caption" css={priceRange}>
            <Text className="card_captionPrice" stylesOverride={priceRangeStyles}>{iconCaption}</Text>
            {iconUrl && (
                <CmsImageLoader className="card_captionImg"
                                css={{ maxWidth: "150px" }}
                                url={iconUrl}
                                alt={imageAlt}/>
            )}
          </div>
        )}
      </div>

    </div>
  );
};

Card.defaultProps = {
  color: "primary"
};

Card.propTypes = {
  color: PropTypes.oneOf([
    "brand",
    "primary",
    "secondary",
    "success",
    "error",
    "warning",
    "info",
  ]),
  imageUrl: PropTypes.string,
  imageAlt: PropTypes.string,
  kicker: PropTypes.string,
  header: PropTypes.string,
  buttonTheme: PropTypes.string,
  ctaUrl: PropTypes.string,
  ctaText: PropTypes.string,
  iconUrl: PropTypes.string,
  iconCaption: PropTypes.string,
  videoId: PropTypes.string,
  videoProvider: PropTypes.string,
  isVideo: PropTypes.bool,
  text: PropTypes.string,
  stylesOverride: PropTypes.object
};

export default Card;
